/**
 * P0-DISCOVERY-03 — Clip del Día.
 *
 * Compact home card that surfaces the first available editorial clip
 * (MOCK_VIRAL_CLIPS) and routes the user to /media-blitz. No autoplay,
 * no video assets — pure metadata card.
 */
import { useEffect } from "react";
import { Link } from "@tanstack/react-router";
import { Film } from "lucide-react";
import { MOCK_VIRAL_CLIPS } from "@/lib/demo/executiveDemoMock";
import { trackEvent } from "@/lib/audit";

export function ClipOfTheDayCard() {
  const clip = MOCK_VIRAL_CLIPS[0];
  useEffect(() => {
    if (clip) void trackEvent("clip_of_day_shown", { id: clip.id });
  }, [clip]);
  if (!clip) return null;
  return (
    <Link
      to="/media-blitz"
      onClick={() => void trackEvent("clip_of_day_opened", { id: clip.id })}
      className="flex items-center gap-3 rounded-2xl border border-border/60 bg-background/70 p-3 shadow-sm transition active:scale-[0.99] hover:bg-background"
      aria-label="Clip del día — ver en Media Blitz"
    >
      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary/15">
        <Film className="h-5 w-5 text-primary" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-[9px] font-black uppercase tracking-widest text-primary">
          🎬 Clip del Día
        </div>
        <div className="truncate text-sm font-black leading-tight">{clip.title}</div>
        <div className="truncate text-[10px] text-muted-foreground">
          {clip.nation_code} · {clip.platform} · {clip.views.toLocaleString()} vistas
        </div>
      </div>
      <span className="shrink-0 rounded-full bg-primary px-3 py-1 text-[11px] font-black text-primary-foreground">
        Ver clip
      </span>
    </Link>
  );
}
